import { DateTime } from 'luxon'

export const parseDate = (date: string | DateTime) => {
  if (typeof date === 'string') {
    return DateTime.fromISO(date)
  }
  return date
}
